import { call, put, takeEvery } from "redux-saga/effects";
import {
    GET_MERCHANT_PAYMENT_FILE_LIST,
    GET_MERCHANT_PAYMENT_FILE_SEARCH,
    GET_MERCHANT_PAYMENT_DETAIL_LIST
} from "./actionTypes"

import {
    getMerchantPaymentFileListSuccess,
    getMerchantPaymentFileSearchSuccess,
    getMerchantPaymentDetailListSuccess,
    merchantPaymentFileApiError
} from "./actions"

import {

    getMerchantPaymentFileList,
    getMerchantPaymentFileSearch,
    getMerchantPaymentDetailList,
} from "../../helpers/backend_helper/backend_helper"

function* onGetMerchantPaymentFileList({ payload: record })  {
    try {
        const response = yield call(getMerchantPaymentFileList,record)
        yield put(getMerchantPaymentFileListSuccess(response))
    } catch (error) {
        yield put(merchantPaymentFileApiError(error))
    }
}
function* onGetMerchantPaymentFileSearch({ payload: record }) {
    try {
        const response = yield call(getMerchantPaymentFileSearch, record)
        yield put(getMerchantPaymentFileSearchSuccess(response))
    } catch (error) {
        yield put(merchantPaymentFileApiError(error))
    }
}
function* onGetMerchantPaymentDetailList({ payload: guid })  {
    try {
        const response = yield call(getMerchantPaymentDetailList,guid)
        yield put(getMerchantPaymentDetailListSuccess(response))
    } catch (error) {
        yield put(merchantPaymentFileApiError(error))
    }
}

function* merchantPaymentFileManagementSaga() {
    yield takeEvery(GET_MERCHANT_PAYMENT_FILE_LIST, onGetMerchantPaymentFileList)
    yield takeEvery(GET_MERCHANT_PAYMENT_FILE_SEARCH, onGetMerchantPaymentFileSearch)
    yield takeEvery(GET_MERCHANT_PAYMENT_DETAIL_LIST, onGetMerchantPaymentDetailList)
}

export default merchantPaymentFileManagementSaga
